import { render } from "./Main.vue?vue&type=template&id=eb4a885e&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=eb4a885e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-eb4a885e"

export default script